export const selectorGetGlobalAccountName = (state) => state.entities.global?.accountName;

export const selectAccountName = selectorGetGlobalAccountName;

export const selectGlobalAccountID = (state) => state?.entities?.global?.accountID;
